import { app } from '../../../bootstrap/core';
import { pdfViewerComponent } from './pdfViewer.component';
import { PdfViewerService } from './pdfViewer.service';

app.component('pdfViewerJs', pdfViewerComponent);
app.service('pdfViewerService', PdfViewerService);
